import { _QueryResources } from 'datx-jsonapi-react';
import { omitBy, isNil } from 'lodash';

import { Track } from '@/resources/Track';

export interface ITrackFilters {
  event_id: string;
  poster_only_sessions?: boolean;
  scope?: string;
}

export const queryMainTrack = (eventId: string): _QueryResources<Track> => {
  return eventId
    ? [
        Track,
        {
          filter: { event_id: eventId, main: 'true' },
        },
      ]
    : null;
};

export const queryAllTracks = (filters: ITrackFilters): _QueryResources<Track> => {
  return filters.event_id
    ? [
        Track,
        {
          sort: 'position',
          filter: omitBy(filters, isNil),
          params: [
            {
              key: 'page[size]',
              value: '500',
            },
          ],
        },
      ]
    : null;
};
